import 'vuetify/styles'
import 'remixicon/fonts/remixicon.css'

import { h } from 'vue'
import { createVuetify, type IconProps } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
// Labs-компонент — компактная иконочная кнопка
import { VIconBtn } from 'vuetify/labs/VIconBtn'
// Русская локаль для компонентов Vuetify (VDatePicker и др.)
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'
import { useI18n } from 'vue-i18n'
import { i18n } from './i18n'

export const vuetify = createVuetify({
  components: {
    ...components,
    VIconBtn,
  },
  directives,

  locale: {
    adapter: createVueI18nAdapter({ i18n: i18n as any, useI18n }),
  },

  icons: {
    // Указываем наш сет как основной
    defaultSet: 'custom',
    // Маппинг внутренних иконок Vuetify на классы remixicon
    aliases: {
      // Чекбоксы
      checkboxOn: 'ri-checkbox-fill',
      checkboxOff: 'ri-checkbox-blank-line',
      checkboxIndeterminate: 'ri-checkbox-indeterminate-fill',
      // Общие
      dropdown: 'ri-arrow-down-s-line',
      clear: 'ri-close-line',
      complete: 'ri-check-line',
      cancel: 'ri-close-circle-line',
      close: 'ri-close-line',
      delete: 'ri-close-circle-line',
      prev: 'ri-arrow-left-s-line',
      next: 'ri-arrow-right-s-line',
      delimiter: 'ri-circle-fill',
      sort: 'ri-arrow-up-down-line',
      expand: 'ri-arrow-down-s-line',
      menu: 'ri-menu-line',
      subgroup: 'ri-arrow-down-s-line',
      // v-file-input
      file: 'ri-attachment-2',
      // v-select / v-combobox
      collapse: 'ri-arrow-up-s-line',
      // v-rating
      ratingEmpty: 'ri-star-line',
      ratingFull: 'ri-star-fill',
      ratingHalf: 'ri-star-half-fill',
      // v-alert
      success: 'ri-checkbox-circle-fill',
      info: 'ri-information-fill',
      warning: 'ri-alert-fill',
      error: 'ri-close-circle-fill',
      // Радио
      radioOn: 'ri-radio-button-fill',
      radioOff: 'ri-checkbox-blank-circle-line',
      // Загрузка
      loading: 'ri-loader-4-line',
    },
    sets: {
      custom: {
        component: (props: IconProps) => {
          // Если в props.icon прилетает путь к файлу (результат импорта SVG)
          const isFilePath =
            typeof props.icon === 'string' &&
            (props.icon.includes('/') ||
              props.icon.includes('data:image') ||
              props.icon.includes('blob:'))

          if (isFilePath) {
            return h('img', {
              src: props.icon,
              style: 'width: 24px; height: 24px; object-fit: contain; flex-shrink: 0;',
            })
          }

          return h(props.tag, {
            ...props,
            class: [props.icon],
            tag: undefined,
            icon: undefined,
          })
        },
      },
    },
  },

  theme: {
    defaultTheme: 'dark',
    themes: {
      dark: {
        colors: {
          primary: '#5237EA',
          'on-primary': '#F7F7F7',
          surface: '#1E2532',
          'on-surface': '#F7F7F7',
          disabled: '#485267',
          // фоновые
          background: '#151822', // --dark-background
          'background-extra': '#0B101A', // --dark-extra
          light: '#F7F7F7', // --light

          // primary-оттенки
          'primary-light': '#7484ED',
          'primary-dark': '#2E3999',

          // статусы
          secondary: '#7A889B',
          success: '#71E286',
          warning: '#FF9F43',
          error: '#FF3737',

          // бордеры / stroke
          'border-dark': '#2D3749', // --dark-stroke

          // текст
          'text-disabled': '#8592AD', // --disable-text

          // оверлеи
          'light-overlay': '#FFFFFF',
          'blur-overlay': '#829ED8',

          // тень slide-out панелей
          'sheet-shadow': '#000000',

          // сервисный фон
          'service-works-bg': '#FF3737',

          // Тултипы — тёмный фон со светлым текстом
          'inverse-surface': '#2D3749',
          'on-inverse-surface': '#F7F7F7',

          // Цвета для анимированных градиентных рамок
          'indigo-glow': '#6366F1',
          'purple-glow': '#A855F7',
          'emerald-glow': '#10B981',
          'blue-glow': '#3B82F6',
        },
        variables: {
          // прозрачности для rgba(var(--v-theme-color), var(--v-opacity))
          'light-overlay-opacity': 0.3,
          'light-overlay-50-opacity': 0.5,
          'blur-overlay-opacity': 0.25,
          'sheet-shadow-opacity': 0.2,
          'service-works-bg-opacity': 0.5,
        },
      },
    },
  },

  defaults: {
    VBtn: {
      rounded: 'lg',
      style: {
        textTransform: 'none',
        letterSpacing: '0',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '120%',
      },
    },
    // Тултипы — тёмный фон
    VTooltip: {
      contentClass: 'bg-inverse-surface',
    },
    // Сброс глобальных дефолтов VBtn внутри VDatePicker
    VDatePicker: {
      VBtn: {
        size: 'default',
        rounded: 'circle',
        class: '',
      },
    },
  },
})
